import { useMemo, useCallback } from "react";
import { CASE_STUDY_CARDS } from "./CreatorCaseStudies.constants";

export const useCreatorCaseStudies = (customCards) => {
  const cards = useMemo(() => {
    return customCards && customCards.length > 0
      ? customCards
      : CASE_STUDY_CARDS;
  }, [customCards]);

  const handleCardClick = useCallback((linkUrl) => {
    if (linkUrl && typeof window !== "undefined") {
      window.open(linkUrl, "_blank", "noopener,noreferrer");
    }
  }, []);

  return {
    cards,
    handleCardClick,
  };
};
